import axios, { AxiosRequestConfig, Method } from 'axios';

abstract class BaseApiService {
  private readonly basePath: string;

  // базовый хост всегда твой бэкенд
  private readonly host =
      process.env.NODE_ENV === 'production'
          ? 'https://api.cyberfit.pro'
          : 'https://api.cyberfit.pro'; // можно заменить на локальный dev-сервер

  protected constructor(basePath: string) {
    this.basePath = basePath.replace(/^\/+/, '');
  }

  /** GET-запрос */
  protected GET<T>(path = '', options?: AxiosRequestConfig): Promise<T> {
    const reqPath = path ? `${this.basePath}/${path.replace(/^\/+/, '')}` : this.basePath;
    return this.safeFetch(reqPath, 'get', undefined, options);
  }

  /** GET по ID */
  protected GETBYID<T>(id: string, options?: AxiosRequestConfig): Promise<T> {
    const reqPath = `${this.basePath}/${id}`;
    return this.safeFetch(reqPath, 'get', undefined, options);
  }

  /** POST-запрос */
  protected POST<T>(path = '', data?: any, options?: AxiosRequestConfig): Promise<T> {
    const reqPath = path ? `${this.basePath}/${path.replace(/^\/+/, '')}` : this.basePath;
    return this.safeFetch(reqPath, 'post', data, options);
  }

  /** PUT-запрос */
  protected PUT<T>(path = '', data?: any, options?: AxiosRequestConfig): Promise<T> {
    const reqPath = path ? `${this.basePath}/${path.replace(/^\/+/, '')}` : this.basePath;
    return this.safeFetch(reqPath, 'put', data, options);
  }

  /** DELETE-запрос */
  protected DELETE<T>(path = '', data?: any, options?: AxiosRequestConfig): Promise<T> {
    const reqPath = path ? `${this.basePath}/${path.replace(/^\/+/, '')}` : this.basePath;
    return this.safeFetch(reqPath, 'delete', data, options);
  }

  /** Базовый метод запроса */
  private async safeFetch(
      path: string,
      method: Method,
      data?: any,
      options: AxiosRequestConfig = {},
  ): Promise<any> {
    // Добавляем Content-Type по умолчанию
    if (!options.headers?.['Content-Type']) {
      options.headers = { 'Content-Type': 'application/json' };
    }

    // Добавляем токен, если есть
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      options.headers.Authorization = `Bearer ${authToken}`;
    }

    // Убираем дублирующиеся слэши
    const url = `/${path.replace(/^\/+/, '')}`;

    try {
      const response = await axios.request({
        baseURL: this.host,
        url,
        method,
        data,
        ...options,
      });

      return response.data;
    } catch (error: any) {
      console.error('[API Error]', error);

      // Здесь НЕ пишем authStore.error, пусть store сам обрабатывает ошибку
      if (error.response?.status && error.response.status !== 500) {
        return Promise.reject(error);
      }
    }
  }
}

export default BaseApiService;
